var _circle, _circle2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeliveryTime(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "url(#paint0_linear_76_6295)",
    fillOpacity: 0.06
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 49.5,
    stroke: "black",
    strokeOpacity: 0.06
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.7266 26.5625C63.9648 26.6895 62.8906 27.0703 62.2266 27.4609C61.9141 27.6367 61.2891 28.1641 60.8203 28.623C60.1074 29.3359 59.9121 29.6094 59.541 30.3809C58.9355 31.6211 58.75 32.5488 58.8184 33.877C58.9551 36.5625 60.4297 38.7695 62.8613 39.9023C63.8184 40.3516 64.6191 40.5273 65.7812 40.5273C68.5352 40.5273 70.8008 39.1602 72.0605 36.7188C73.9355 33.1055 72.2852 28.6035 68.4961 27.0215C67.4414 26.582 65.8496 26.3867 64.7266 26.5625ZM67.3047 28.1836C68.7402 28.6133 70.166 29.7949 70.7812 31.0742C71.8652 33.3105 71.3769 35.918 69.5605 37.5879C68.4961 38.5645 67.2266 39.0625 65.7715 39.0625C64.3555 39.0625 63.1055 38.5645 62.0605 37.5879C60.957 36.5527 60.3809 35.3711 60.2832 33.916C60.2148 32.9102 60.3613 32.0898 60.8008 31.1914C61.9824 28.7012 64.7461 27.4316 67.3047 28.1836Z",
    fill: "url(#paint1_linear_76_6295)",
    stroke: "url(#paint2_linear_76_6295)",
    strokeWidth: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.498 29.3651C65.1367 29.4628 65.0391 29.9022 65.0391 31.3671C65.0293 32.3925 65 32.8319 64.8926 33.0077C64.8145 33.1444 64.7559 33.3983 64.7461 33.5741C64.7461 33.789 64.5605 34.2089 64.209 34.8144C63.916 35.3124 63.6719 35.8202 63.6719 35.9374C63.6719 36.2597 63.8379 36.494 64.1309 36.5917C64.668 36.7772 64.8535 36.6308 65.4785 35.5858C65.8301 34.9901 66.1719 34.5312 66.3379 34.4433C66.8359 34.1503 67.0215 33.2226 66.6406 32.9003C66.5332 32.8124 66.5039 32.4413 66.5039 31.2499V29.6972L66.25 29.5019C65.9961 29.2968 65.8496 29.2772 65.498 29.3651Z",
    fill: "url(#paint3_linear_76_6295)",
    stroke: "url(#paint4_linear_76_6295)",
    strokeWidth: 0.3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4805 37.2168L32.2266 37.4121V40.0489V42.6758H29.2188C26.416 42.6758 26.1914 42.6856 26.0449 42.8516C25.8105 43.1153 25.8301 43.6817 26.084 43.9063C26.2793 44.0821 26.4941 44.0918 29.2578 44.1211L32.2266 44.1504V44.6289C32.2266 45.2246 32.4609 45.5078 32.9492 45.5078C33.4082 45.5078 33.6914 45.1465 33.6914 44.5703V44.1406H35.2539C37.0898 44.1406 37.4414 44.0528 37.5488 43.5547C37.5977 43.3203 37.5684 43.1739 37.4219 42.9785L37.2363 42.7246L35.459 42.6953L33.6914 42.6758V40.5762V38.4766H37.5488H41.4062V41.0547C41.4062 43.5059 41.416 43.6426 41.6113 43.8867L41.8066 44.1406H44.9805C48.0176 44.1406 48.1543 44.1309 48.3398 43.9453C48.5254 43.7598 48.5352 43.6231 48.5352 41.1133V38.4766H52.4414H56.3477V49.8047V61.1328H45.0195H33.6914V59.0821V57.0313H35.4004C37.0898 57.0313 37.1191 57.0313 37.3535 56.7871C37.666 56.4844 37.666 56.1133 37.3535 55.8106C37.1191 55.5664 37.0898 55.5664 35.4004 55.5664H33.6914V55.0879C33.6914 54.5313 33.4863 54.2285 33.0566 54.1406C32.8418 54.1016 32.6855 54.1406 32.4902 54.2969C32.2656 54.4824 32.2266 54.5801 32.2266 55.0391V55.5664H29.2676C25.8984 55.5664 25.8789 55.5664 25.8789 56.2598C25.8789 56.5137 25.9473 56.709 26.0742 56.836C26.2598 57.0215 26.3965 57.0313 29.248 57.0313H32.2266V61.6406V66.2598L31.9434 66.416C31.4453 66.6992 31.25 67.2949 31.25 68.5254C31.25 69.4629 31.2793 69.6582 31.4746 70.0293C31.6211 70.293 31.8457 70.5371 32.0898 70.6738C32.4512 70.8887 32.5684 70.8985 34.8145 70.8985L37.1582 70.9082L37.4023 71.2988C38.0371 72.334 39.4727 73.2422 40.8105 73.4473C42.666 73.7305 44.7266 72.8321 45.6738 71.3379L45.9473 70.8985H52.5098H59.0723L59.3555 71.3086C60.3516 72.7637 62.2949 73.6817 63.9648 73.4863C65.5371 73.3106 67.0215 72.4024 67.7539 71.1719L67.9102 70.9082L70.5176 70.8789C72.9883 70.8496 73.1445 70.8399 73.4082 70.6446C74.0332 70.1856 74.1211 69.9219 74.1211 68.5352C74.1211 67.1973 74.0527 66.9434 73.6133 66.5332C73.4961 66.416 73.2715 66.2793 73.125 66.2207L72.8516 66.1133V61.6992C72.8516 59.0039 72.8125 57.1387 72.7539 56.9141C72.6367 56.5039 68.5938 50.2149 68.1348 49.7266C67.959 49.541 67.6465 49.3067 67.4316 49.1895C67.0508 48.9746 66.9434 48.9746 62.4316 48.9453L57.8125 48.916L57.793 43.1641C57.7637 37.793 57.7539 37.4024 57.5879 37.2364C57.4219 37.0703 56.7676 37.0606 45.0781 37.0313L32.7441 37.0117L32.4805 37.2168ZM47.0703 40.5762V42.6758H44.9707H42.8711V40.5762V38.4766H44.9707H47.0703V40.5762ZM66.7871 50.5371C66.9824 50.6348 67.7051 51.6602 69.2285 54.0137L71.3867 57.3438V58.0176V58.6914H70.6055C69.668 58.6914 69.4336 58.8477 69.4336 59.4629C69.4336 60.0196 69.668 60.1563 70.625 60.1563H71.3867V63.1348V66.1133H69.6582L67.9199 66.1035L67.5879 65.6153C66.5234 64.0528 64.4629 63.2129 62.5879 63.6035C61.2598 63.8672 60.0977 64.6192 59.3652 65.6934L59.0723 66.1133H58.4473H57.8125V58.252V50.3906H62.1582C65.791 50.3906 66.5625 50.4102 66.7871 50.5371ZM56.3477 64.3555V66.1133H51.1523L45.9473 66.1035L45.7031 65.7129C45.3418 65.1074 44.4629 64.3653 43.7207 64.0039C42.3242 63.3399 40.791 63.3399 39.375 64.0137C38.6035 64.375 37.6562 65.2051 37.3438 65.7715L37.1582 66.1133H35.4297H33.6914V64.3555V62.5977H45.0195H56.3477V64.3555ZM42.998 65.3028C43.7305 65.6348 44.5312 66.4844 44.834 67.2559C45.6152 69.2871 44.3359 71.5039 42.0996 71.9824C40.6641 72.2852 39.0039 71.3574 38.3105 69.8731C38.0859 69.3848 38.0469 69.1504 38.0371 68.5059C38.0371 67.8321 38.0859 67.6367 38.3398 67.0899C38.8184 66.0742 39.7363 65.3028 40.791 65.0391C41.3672 64.9024 42.3633 65.0196 42.998 65.3028ZM64.2676 65.0781C65.8887 65.459 67.002 66.8555 67.002 68.5059C67.002 69.5313 66.7188 70.2149 65.9766 70.9571C63.8965 73.0371 60.5371 71.9238 60.0293 68.9844C59.7363 67.2656 60.9863 65.4688 62.7637 65.0489C63.3008 64.9219 63.6523 64.9317 64.2676 65.0781ZM36.5723 68.5059V69.4336L34.668 69.4141L32.7637 69.3848L32.7344 68.6133C32.7148 68.1836 32.7246 67.7832 32.7539 67.7051C32.793 67.6074 33.2031 67.5781 34.6875 67.5781H36.5723V68.5059ZM58.5449 68.5059V69.4336H52.5293H46.5234V68.5059V67.5781H52.5293H58.5449V68.5059ZM72.6953 67.7344C72.7734 67.9297 72.7734 69.0821 72.6953 69.2774C72.6465 69.4141 72.3633 69.4336 70.5566 69.4336H68.4766V68.5059V67.5781H70.5566C72.3633 67.5781 72.6465 67.5977 72.6953 67.7344Z",
    fill: "url(#paint5_linear_76_6295)",
    stroke: "url(#paint6_linear_76_6295)",
    strokeWidth: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.082 51.6601C58.8965 51.8456 58.8867 51.9824 58.8867 54.6386C58.8867 57.2949 58.8965 57.4316 59.082 57.6171C59.2676 57.8027 59.4043 57.8124 64.2383 57.8124C69.8047 57.8124 69.6289 57.832 69.6289 57.1484C69.6289 56.8456 69.3652 56.3769 68.0566 54.3456C67.1973 52.998 66.377 51.8066 66.25 51.6796C66.0059 51.4648 65.9961 51.4648 62.6367 51.4648C59.4043 51.4648 59.2676 51.4746 59.082 51.6601ZM66.4746 54.6386L67.5684 56.3476H63.9648H60.3516V54.6386V52.9296H62.8711L65.3809 52.9394L66.4746 54.6386Z",
    fill: "url(#paint7_linear_76_6295)",
    stroke: "url(#paint8_linear_76_6295)",
    strokeWidth: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2285 58.8086C58.9551 58.9648 58.8867 59.082 58.8867 59.4434C58.8867 59.6387 58.9648 59.8438 59.082 59.9609C59.2578 60.1367 59.4043 60.1562 60.5762 60.1562C61.8164 60.1562 61.8945 60.1465 62.0898 59.9316C62.3926 59.6094 62.373 59.1504 62.0508 58.8965C61.8164 58.7109 61.6602 58.6914 60.6055 58.6914C59.9121 58.6914 59.3457 58.7402 59.2285 58.8086Z",
    fill: "url(#paint9_linear_76_6295)",
    stroke: "url(#paint10_linear_76_6295)",
    strokeWidth: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.752 66.465C40.5176 66.5529 40.1758 66.797 39.9512 67.0411C38.4961 68.6232 39.9414 71.0841 42.0703 70.6056C42.8125 70.4396 43.4766 69.795 43.6524 69.0529C43.8477 68.2423 43.6621 67.5783 43.0762 67.0021C42.4121 66.3283 41.6406 66.1525 40.752 66.465ZM41.836 67.881C41.9629 67.9493 42.1289 68.1154 42.1875 68.2618C42.4121 68.8087 41.8262 69.3849 41.2793 69.131C40.7617 68.8966 40.7324 68.0763 41.2305 67.8712C41.5332 67.754 41.5528 67.754 41.836 67.881Z",
    fill: "url(#paint11_linear_76_6295)",
    stroke: "url(#paint12_linear_76_6295)",
    strokeWidth: 0.3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M62.7637 66.4452C61.9238 66.748 61.3379 67.5878 61.3281 68.4863C61.3184 70.1269 63.0567 71.1718 64.5313 70.4199C65.2637 70.039 65.6543 69.3749 65.6543 68.5058C65.6543 66.9726 64.1992 65.9374 62.7637 66.4452ZM63.9746 68.0566C64.3359 68.4179 64.3359 68.5937 63.9649 68.9648C63.7207 69.1992 63.6133 69.248 63.3984 69.1992C62.8125 69.0527 62.6172 68.4277 63.0371 68.0175C63.3496 67.6952 63.6231 67.7148 63.9746 68.0566Z",
    fill: "url(#paint13_linear_76_6295)",
    stroke: "url(#paint14_linear_76_6295)",
    strokeWidth: 0.3
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3555 44.2578C39.1797 44.4434 39.1602 44.5996 39.1602 45.6738V46.875H34.3359C31.2305 46.875 29.4141 46.9141 29.2285 46.9727C28.9551 47.0703 28.7109 47.4121 28.7109 47.6953C28.7109 47.7637 28.7988 47.9395 28.916 48.0859L29.1113 48.3398H34.6777C41.1719 48.3398 40.625 48.4375 40.625 47.2461V46.5332L42.2949 48.1934L43.9648 49.8535L42.3145 51.4355L40.6738 53.0176L40.625 52.334C40.5469 51.1816 41.0449 51.2695 34.668 51.2695C29.4922 51.2695 29.209 51.2793 28.9941 51.4551C28.6816 51.709 28.6816 52.2949 28.9941 52.5488C29.209 52.7246 29.4824 52.7344 34.1895 52.7344H39.1602V53.9453C39.1602 55.3711 39.2676 55.6055 39.8828 55.6055C40.2246 55.6055 40.3906 55.459 42.9688 52.8809C45.498 50.3516 45.7031 50.127 45.7031 49.8047C45.7129 49.4824 45.5273 49.2871 42.9688 46.748C40.459 44.2773 40.1953 44.043 39.8926 44.043C39.6777 44.043 39.4922 44.1211 39.3555 44.2578Z",
    fill: "url(#paint15_linear_76_6295)",
    stroke: "url(#paint16_linear_76_6295)",
    strokeWidth: 0.3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_76_6295",
    x1: 50,
    y1: 0,
    x2: 50,
    y2: 100,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1194D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0570A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_76_6295",
    x1: 65.8209,
    y1: 40.5273,
    x2: 65.8209,
    y2: 26.4983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1194D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0570A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_76_6295",
    x1: 65.8209,
    y1: 40.5273,
    x2: 65.8209,
    y2: 26.4983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1194D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0570A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_76_6295",
    x1: 65.2578,
    y1: 36.6602,
    x2: 65.2578,
    y2: 29.3156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1194D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0570A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_76_6295",
    x1: 65.2578,
    y1: 36.6602,
    x2: 65.2578,
    y2: 29.3156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1194D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0570A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_76_6295",
    x1: 50,
    y1: 73.5125,
    x2: 50,
    y2: 37.0117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1194D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0570A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_76_6295",
    x1: 50,
    y1: 73.5125,
    x2: 50,
    y2: 37.0117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1194D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0570A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_76_6295",
    x1: 64.2581,
    y1: 57.8125,
    x2: 64.2581,
    y2: 51.4648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1194D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0570A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_76_6295",
    x1: 64.2581,
    y1: 57.8125,
    x2: 64.2581,
    y2: 51.4648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1194D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0570A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_76_6295",
    x1: 60.596,
    y1: 60.1562,
    x2: 60.596,
    y2: 58.6914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1194D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0570A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_76_6295",
    x1: 60.596,
    y1: 60.1562,
    x2: 60.596,
    y2: 58.6914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1194D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0570A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_76_6295",
    x1: 41.5448,
    y1: 70.6663,
    x2: 41.5448,
    y2: 66.3153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1194D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0570A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_76_6295",
    x1: 41.5448,
    y1: 70.6663,
    x2: 41.5448,
    y2: 66.3153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1194D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0570A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_76_6295",
    x1: 63.4912,
    y1: 70.6682,
    x2: 63.4912,
    y2: 66.3148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1194D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0570A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_76_6295",
    x1: 63.4912,
    y1: 70.6682,
    x2: 63.4912,
    y2: 66.3148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1194D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0570A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_76_6295",
    x1: 37.2072,
    y1: 55.6055,
    x2: 37.2072,
    y2: 44.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1194D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0570A8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_76_6295",
    x1: 37.2072,
    y1: 55.6055,
    x2: 37.2072,
    y2: 44.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1194D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0570A8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryTime);
export default __webpack_public_path__ + "static/media/deliveryTime.d9c074b95a536efce32e572e68b38c46.svg";
export { ForwardRef as ReactComponent };